const Storage = {
	get(key, initialValue) {
		try {
			// Get from local storage by key
			const item = localStorage.getItem(key);
			if (initialValue === '') return item;
			// Parse stored json or if none return initialValue
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			// If error also return initialValue
			console.log(error);
			return initialValue;
		}
	},
	set(key, value) {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		} catch (err) {
			console.log(err);
		}
	},
	remove(key) {
		localStorage.removeItem(key);
	},
	removeAll() {
		localStorage.clear();
	},
};

export default Storage;
